import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

import { IncludedBox } from '../../OrderHistory.style';

export const IncludedNameBox = superstyled({
  tag: IncludedBox,
  name: 'OrderRow',
  slot: 'IncludedNameBox',
  styles: { maxWidth: '275px' },
});

export const FulfillmentStatusText = superstyled({
  tag: Text,
  name: 'OrderRow',
  slot: 'FulfillmentStatusText',
  styles: { textTransform: 'capitalize', paddingTop: '3px' },
});

export const IncludedStatusRow = superstyled({
  tag: IncludedBox,
  name: 'OrderRow',
  slot: 'IncludedStatusRow',
  styles: {
    padding: '5px 0 5px 18px',
    display: 'flex',
    alignItems: 'center',
  },
});

export const IncludedStatusText = superstyled({
  tag: Text,
  name: 'OrderRow',
  slot: 'IncludedStatusText',
  styles: { textTransform: 'capitalize' },
});

export const OrderDateText = superstyled({
  tag: Text,
  name: 'OrderRow',
  slot: 'OrderDateText',
  styles: { flex: 1, paddingTop: '3px' },
});
